import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PromptCiergePage from "@/pages/PromptCiergePage";
import PublicReceiptPage from "@/pages/PublicReceiptPage";

function App() {
    return (
        <div className="App min-h-screen bg-slate-50 text-slate-900 font-body">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PromptCiergePage />} />
                    <Route path="/r/:hash" element={<PublicReceiptPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
